export default {
    font1: `'Alata', sans-serif`,
    font2: `'Ubuntu', sans-serif`,
    font3: `'Public Sans', sans-serif`,
    font4: `Roboto, sans-serif`,
    red: '#D13130',
    darkBlue: '#0D71B5',
    blue: '#11B0DA',
    grey: '#b7b7b7',
}